export { default as TestContentAnswers } from 'components/test/test-content-answers';
export { default as TestContentFooter } from 'components/test/test-content-footer';
export { default as TestContentHeader } from 'components/test/test-content-header';
export { default as TestContent } from 'components/test/test-content';
export { default as TestFinish } from 'components/test/test-finish';
export { default as TestAddBtn } from 'components/test/test-form/test-add-btn';
export { default as TestFormAnswers } from 'components/test/test-form/test-form-answers';
export { default as TestFormBasic } from 'components/test/test-form/test-form-basic';
export { default as TestFormRadio } from 'components/test/test-form/test-form-radio';
